export class Cookie {
  constructor() {
    this._cookie = document.querySelector('[data-cookie]');

    this._documentClickHandler = this._documentClickHandler.bind(this);
  }

  init() {
    if (!this._cookie) {
      return;
    }

    document.addEventListener('click', this._documentClickHandler);
  }

  _documentClickHandler(evt) {
    const target = evt.target;

    if (!target.closest('[data-cookie-button]')) {
      return;
    }

    if (!this._cookie.classList.contains('is-hidden')) {
      this._cookie.classList.add('is-hidden');
      this._setCookie('COOKIE_ACCEPTED', true, {'max-age': 31556926});
    }
  }

  _setCookie(name, value, options = {}) {
    options = {
      path: '/',
      ...options,
    };

    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in options) {
      updatedCookie += "; " + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += "=" + optionValue;
      }
    }

    document.cookie = updatedCookie;
  }
}
